import { $http } from "@/assets/js/appFunc";

export const getDocumentList = (context) => {
    if (context.state.documentList.length === 0) {
        const req = {
            type: "GET",
            url: "/documents/templates",
            data: null
        };
        $http(req).then(
            data => context.commit("setDocumentsList", data),
            error => console.log(error)
        );
    }
};

export const deleteDocument = (context, document) => {
    delete document.__index;
    const req = {
        type: "PUT",
        url: `/documents/templates/${document.code}/deactivate`,
        data: null
    };
    $http(req).then(
        data => context.commit("deleteDocument", document),
        error => console.log(error)
    );
};

export const deleteDocumentMultiple = (context, list) => {
    const payload = list.map(document => document.code);
    const req = {
        type: "PUT",
        url: "/documents/templates/deactivate",
        data: payload
    };
    $http(req).then(
        data => {
            for (const document of list) {
                delete document.__index;
                context.commit("deleteDocument", document);
            }
        }
    );
};
